export default __webpack_public_path__ + "static/media/407.4b6e669d.png";